(() => {
  if (window.softServeCartGift) return;
  const first = document.querySelector('[data-cart-free-product]');
  if (!first) return;
  const config = first.dataset;
  const qualifying = new Set(config.qualifying.split(',').map(Number));
  const giftId = Number(config.productId), minimum = Number(config.minimum);
  const panels = () => Array.from(document.querySelectorAll('[data-cart-free-product]'));
  let queue = Promise.resolve(), busy = false, lastCart, checkoutApproved = false;
  const count = cart => cart.items.reduce((sum, item) => sum + (qualifying.has(item.product_id) ? item.quantity : 0), 0);
  const gifts = cart => cart.items.filter(item => item.product_id === giftId);
  async function request(path, body) {
    const response = await fetch(config.root + path, {
      method: body ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store',
      headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
      ...(body ? {body: JSON.stringify(body)} : {}), signal: AbortSignal.timeout(12000)
    });
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || config.error);
    return result;
  }
  function showError(error) {
    panels().forEach(panel => {
      const message = panel.querySelector('[data-gift-error]');
      message.textContent = error.message || config.error;
      message.hidden = false;
    });
  }
  function render(cart) {
    lastCart = cart;
    const remaining = Math.max(0, minimum - count(cart));
    const claimed = gifts(cart).some(item => item.final_line_price === 0);
    panels().forEach(panel => {
      const select = panel.querySelector('[data-gift-size]');
      const available = Array.from(select.options).some(option => option.value && !option.disabled);
      panel.querySelector('[data-gift-status]').textContent = claimed ? config.added : !available ? config.soldOut : remaining ? config.locked.replace('[remaining]', remaining) : config.ready;
      panel.querySelector('[data-gift-controls]').hidden = remaining > 0 || claimed || !available;
      panel.querySelector('[data-gift-add]').disabled = busy || !select.value || remaining > 0 || claimed;
    });
  }
  function schedule(task) { const next = queue.catch(() => {}).then(task); queue = next; return next; }
  async function reconcile() {
    if (window.softServeSaleCartReady) await window.softServeSaleCartReady;
    let cart = await request('cart.js');
    const updates = {}; let kept = false;
    for (const item of gifts(cart)) {
      const quantity = count(cart) >= minimum && !kept ? 1 : 0;
      kept = kept || quantity === 1;
      if (item.quantity !== quantity) updates[item.key] = quantity;
    }
    if (Object.keys(updates).length) {
      cart = await request('cart/update.js', {updates});
      document.dispatchEvent(new CustomEvent('cart:build'));
    }
    const firstRefresh = !lastCart;
    render(cart);
    if (firstRefresh) document.dispatchEvent(new CustomEvent('cart:build'));
    return cart;
  }
  function refresh() { schedule(reconcile).catch(showError); }
  document.addEventListener('change', event => {
    if (event.target.matches('[data-gift-size]') && lastCart) render(lastCart);
  });
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-gift-add]');
    if (!button || button.disabled || busy) return;
    event.preventDefault();
    const panel = button.closest('[data-cart-free-product]');
    const variantId = Number(panel.querySelector('[data-gift-size]').value);
    if (!variantId) return;
    busy = true; if (lastCart) render(lastCart);
    panels().forEach(item => { item.querySelector('[data-gift-error]').hidden = true; });
    schedule(async () => {
      const cart = await reconcile();
      if (count(cart) < minimum || gifts(cart).length) return;
      await request('cart/add.js', {items: [{id: variantId, quantity: 1, properties: {_offer: 'cart-gift'}}]});
      const updated = await request('cart.js');
      const gift = gifts(updated).find(item => item.variant_id === variantId);
      if (!gift || gift.final_line_price !== 0) {
        if (gift) await request('cart/update.js', {updates: {[gift.key]: 0}});
        document.dispatchEvent(new CustomEvent('cart:build'));
        throw new Error(config.error);
      }
      render(updated); document.dispatchEvent(new CustomEvent('cart:build'));
    }).catch(showError).finally(() => { busy = false; if (lastCart) render(lastCart); });
  });
  document.addEventListener('submit', event => {
    if (checkoutApproved || !event.target.matches('form[action*="/cart"]') || event.submitter?.name !== 'checkout') return;
    event.preventDefault(); event.stopImmediatePropagation();
    const form = event.target, submitter = event.submitter;
    schedule(reconcile).then(() => { checkoutApproved = true; form.requestSubmit(submitter); checkoutApproved = false; }).catch(showError);
  }, true);
  ['cart:updated', 'cart:build', 'ajaxProduct:added'].forEach(name => document.addEventListener(name, refresh));
  window.softServeCartGift = {refresh}; refresh();
})();
